import Vue from 'vue';
import Router from 'vue-router';

import Form from '@/pages/form';
import Results from '@/pages/results';
import ErrorComp from '@/pages/error';
import SystemDown from '@/pages/system-down';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '',
      name: 'home',
      component: Form,
    },
    {
      path: '/results',
      name: 'results',
      component: Results,
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorComp,
    },
    {
      path: '/system-down',
      name: 'system-down',
      component: SystemDown,
    },
  ],
});

export default router;
